module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "block-repeater"
  }, [(this.$store.state) ? _c('div', {
    staticClass: "block-repeater__container"
  }, _vm._l((_vm.props.repeater), function(item, i) {
    return _c('div', {
      ref: "parent",
      refInFor: true,
      staticClass: "block-repeater__item",
      on: {
        "click": function($event) {
          _vm.switchSlide(i)
        }
      }
    }, [_c('div', {
      ref: "child",
      refInFor: true,
      staticClass: "block-repeater__background",
      class: {
        active: i === _vm.types
      },
      style: ({
        backgroundImage: 'url(' + item.image + ')'
      })
    })])
  })) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-92d8f6a8","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./src/components/block/block-image-repeater/block-image-repeater.pug
// module id = 612
// module chunks = 1